import store from "../../store";

const diss_preffix = process.env.VUE_APP_DISS_PREFIX;
const host_diss = process.env.VUE_APP_API_HOST + process.env.VUE_APP_DISS_PREFIX;

export default {
  DISS_HOST: host_diss,
  DISS_INSTANCE_NAME: process.env.VUE_APP_DISS_PREFIX,
  DISS_PREFFIX: diss_preffix,

  getUrl(urlname, action) {
    let url = store.getters['urls/getPattern'](
      this.DISS_INSTANCE_NAME,
      urlname,
      action
    );
    if (url !== '')
      return this.DISS_HOST + url;
    else
      return ''

  },
  getUrlAllowed(urlname, action) {
    return store.getters['urls/getAllowed'](
      process.env.VUE_APP_DISS_PREFIX,
      urlname,
      action
    );
  },
}
